<template>
  <div>
    <a
      class="d-inline-block px-1 text-right text-uppercase" role="button"
      v-for="lang in languages"
      :key="lang"
      @click="changeLang(lang)"
    > <small>{{ lang }}  </small>
    <!-- <img :src="require(`./../assets/images/icons/${lang}.png`)" class="w-50"> -->
    </a>
  </div>
</template>

<script>
export default {
  name: "languageSwitcher",
  data: () => ({ languages: ["ro", "en"] }),
  methods: {
    changeLang(lang) {
      this.$i18n.locale = lang;
    },
  }
};
</script>
